module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Prologue"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue – The Coldest of Cold Cases")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Part01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 1: The Crime")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter01"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" The Tragedy of King Richard III")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter02"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" ‘Under a Heape of Stones and Rubbish’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" CSI: Westminster Abbey")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Boys Who Would be King")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" The Bastardy of Edward’s Children")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" The Lost Boys")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Sometimes They Come Back")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Part02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 2: The Usual Suspects")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" Richard III")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapa"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" Henry VII")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Harry of Buckingham")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Part03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 3: The Unusual Suspects")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" The Cat and the Rat: Richard’s Adherents")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" ‘Divers and Sundry Ways’: Henry’s Adherents")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")])]), _vm._v(" The Outsiders")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-chapalb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Part04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Part 4: The Solution")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")])]), _vm._v(" ‘A Strasbourg Doctor …’")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")])]), _vm._v(" Victims for Sacrifice")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16")])]), _vm._v(" The Dark Triad")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17")])]), _vm._v(" The Once and Future King")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")])]), _vm._v(" The Poisoned Chalice")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc-chapal"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Biblography",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0